module.exports = __webpack_public_path__ + "img/Namibia.4874fee9.png";